export default "__VITE_ASSET__7b6ad910__"